import {
  UploadedDocument,
  useInvalidateUseGetAgencyMembers,
  useRemovePublicDocument,
} from '@urbanx/agx.agencies.client';
import PhotoUpload from '../PhotoUpload';

interface LogoUploadProps {
  logo?: UploadedDocument;
  onImageChange: (doc?: UploadedDocument) => void;
  agencyId: string;
  isDisabled?: boolean;
}

const LogoUpload = ({ logo, onImageChange, agencyId, isDisabled = false }: LogoUploadProps) => {
  const invalidateAgencyMembers = useInvalidateUseGetAgencyMembers();
  const { removePublicDocument: deleteLogo, removePublicDocumentPending: isRemovingLogo } =
    useRemovePublicDocument({
      onSuccess: async () => {
        onImageChange(undefined);
        await invalidateAgencyMembers(agencyId);
      },
      onError: () => {},
    });

  return (
    <PhotoUpload
      photoUri={logo?.publicPath}
      agencyId={agencyId}
      disabled={isDisabled}
      removePending={isRemovingLogo}
      onUploaded={onImageChange}
      onRemove={() => deleteLogo({ filePath: logo?.containerFilePath || '' })}
    />
  );
};

export default LogoUpload;
